<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/production/erpwobom/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item class="noborder" :label="$t('ERPgongdanhao')">
						<el-input disabled v-model="$attrs.bom.no"></el-input>
					</el-form-item>
				</el-form>
			</template>
		</yi_curd_table>
	</div>
</template>
<script type="text/javascript">
	
	export default {
		name: 'web_order_management_erp_work_bom',
		
		data() {
			return {
				columns: [{
					label: 'chanpinbianma',
					prop: 'materialCode',
					width: 130
				}, {
					label: 'chanpinmingcheng',
					prop: 'materialName',
					width: 130
				}, {
					label: 'xuqiuliang',
					prop: 'quantity'
				},{
					label: 'danwei',
					prop: 'unit'
				},{
					label: 'shifoufanchongwuliao',
					prop: 'isRecoil'
				},{
					label: 'shifouxuniwuliao',
					prop: 'isVirtual'
				},{
					label: 'shifouandanbiaoshi',
					prop: 'isOrder'
				},{
					label: 'beizhu',
					prop: 'remark'
				}]
			};
		},

		created() {
			setTimeout(() => {
				this.yt.conditions = {
					erpWoId: this.$attrs.bom.id,
				}
				this.yt.get(1)
			}, 300)
		},
		methods: {
		// beforeAdd(params, url) {
		// 	params.parentId = this.$attrs.type.id
		// 	return params
		// }
		}
	};
</script>
